import _ from "lodash";
/**-- external -- */
import React, { memo, useMemo } from "react";
import { CaretDownFilled } from "@toddle-edu/ds-icons";

/**-- internal -- */
import MoreItemWithToolTip from "UIComponents/MoreItemWithToolTip";
import FilterDropdown from "UIComponents/FilterDropdown";
import { useI18n } from "Hooks";
import { colors } from "Constants";

/**-- relative -- */
import classes from "./GradesCell.scss";
import { filterDropdownStyle, tooltipStyles } from "./GradesCellStyles";

const GradesCell = ({ grades, gradeOptions, mode, onUpdateGrades }) => {
  const { t } = useI18n(["schoolSetup", "common"]);

  const gradeOptionIds = _.map(grades, "id");

  /**
   * This filtering is needed to remove those grades which are deleted but still tagged with nodes
   */
  const filterGrades = _.filter(grades, ({ id }) =>
    _.includes(gradeOptionIds, id)
  );

  const gradeItems = _.map(filterGrades, "name");

  const gradeIds = _.map(filterGrades, ({ id }) => id);
  const areGradeEmpty = _.isEmpty(gradeItems);

  const gradeOptionsByKey = useMemo(() => {
    return _.keyBy(gradeOptions, "id");
  }, [gradeOptions]);

  const updateFilterDropdown = value => {
    const newGrades = _.map(value, id => {
      const { name } = gradeOptionsByKey[id];
      return { id, name };
    });
    onUpdateGrades({ nodeGrades: newGrades });
  };

  const gradesLabelElement = (
    <div className={classes.tooltipSvgContainer}>
      <MoreItemWithToolTip
        items={gradeItems}
        tooltipPlacement={"right"}
        length={2}
        moreJoinSymbol={", +"}
        moreStyle={tooltipStyles.tooltipStyle}
        valueStyle={{
          ...tooltipStyles.tooltipStyle,
          color: areGradeEmpty
            ? colors.textDisabled
            : tooltipStyles.tooltipStyle.color,
        }}
        noItemText={t("schoolSetup:no_label_selected", {
          label: t("common:lowercase", {
            text: t("common:grade_plural"),
          }),
        })}
        moreAll={false}
        trigger={["hover", "focus"]}
        stopPropagationOnLabelClick={false}
      />
      {mode === "edit" && (
        <div className={classes.svgContainer}>
          <CaretDownFilled variant={"subtle"} />
        </div>
      )}
    </div>
  );

  return (
    <div
      className={classes.container}
      style={areGradeEmpty ? { color: colors.yellow500 } : {}}
    >
      {mode === "edit" ? (
        <FilterDropdown
          options={_.map(gradeOptions, ({ id, name }) => ({
            label: name,
            value: id,
          }))}
          label="grade_plural"
          value={gradeIds}
          updateInputField={updateFilterDropdown}
          allOptionLabel={"All"}
          isCheckList={true}
          filterBoxStyle={filterDropdownStyle.filterBoxStyle}
          buttonDropDownContainerStyle={
            filterDropdownStyle.buttonDropDownContainerStyle
          }
          filterTextStyle={filterDropdownStyle.filterTextStyle}
          nameTextStyle={filterDropdownStyle.nameTextStyle}
          emptyTextStyle={filterDropdownStyle.emptyTextStyle}
          buttonComponentStyle={filterDropdownStyle.buttonComponentStyle}
          parentContainerStyle={filterDropdownStyle.parentContainerStyle}
          buttonParentStyle={filterDropdownStyle.buttonParentStyle}
          shouldMountDropDownOnButtonClick={true}
          emptyOptionsDropdownText={t("common:no_label_found", {
            label: t("common:lowercase", {
              text: t("common:grade_plural"),
            }),
          })}
          buttonComponent={gradesLabelElement}
        />
      ) : (
        gradesLabelElement
      )}
    </div>
  );
};

const shouldRender = (prevProps, nextProps) => {
  return (
    prevProps.mode === nextProps.mode &&
    prevProps.grades === nextProps.grades &&
    prevProps.onUpdateGrades === nextProps.onUpdateGrades
  );
};

export default memo(GradesCell, shouldRender);
